import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-multi-select-chips',
  imports: [CommonModule],
  templateUrl: './multi-select-chips.html',
  styleUrl: './multi-select-chips.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectChipsComponent),
      multi: true
    }
  ]
})
export class MultiSelectChipsComponent implements ControlValueAccessor {
  @Input() options: string[] = [];
  @Input() placeholder = 'Select...';

  selected: string[] = [];
  disabled = false;

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string[] | null): void {
    this.selected = Array.isArray(value) ? [...value] : [];
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  isSelected(option: string): boolean {
    return this.selected.includes(option);
  }

  toggle(option: string): void {
    if (this.disabled) return;
    this.onTouched();

    if (this.isSelected(option)) {
      this.selected = this.selected.filter(s => s !== option);
    } else {
      this.selected = [...this.selected, option];
    }
    this.onChange(this.selected);
  }

  remove(option: string): void {
    if (this.disabled) return;
    this.selected = this.selected.filter(s => s !== option);
    this.onChange(this.selected);
  }
}
